import { format } from 'date-fns';
import React from 'react';
import { Dimensions, Platform, StyleSheet } from 'react-native';

import { Box, Text } from '@components/Restyle';
import { getProjectActivityMessage } from '@screens/Projects/Report/TaskDetail';

export enum ProjectActivityType {
  TaskDocument = 'TaskDocument',
  ProjectDocument = 'ProjectDocument',
  ProjectCreated = 'ProjectCreated',
  ProjectAssigned = 'ProjectAssigned',
  ProjectUnassigned = 'ProjectUnassigned',
  ProjectUnassignedSelf = 'ProjectUnassignedSelf',
  ProjectCompleted = 'ProjectCompleted',
  MessageSent = 'MessageSent',
  TaskCreated = 'TaskCreated',
  TaskAssigned = 'TaskAssigned',
  TaskUnassigned = 'TaskUnassigned',
  TaskUnassignedSelf = 'TaskUnassignedSelf',
  TaskCompleted = 'TaskCompleted',
  TaskCompletedRestore = 'TaskCompletedRestore',
  Default = '',
}

interface Log {
  user: {
    name: string;
  };
  event: ProjectActivityType;
  attachment: {
    body: string;
  };
  createdAt: string;
}

export const ActivityLogMobile = ({
  log,
  role,
}: {
  log: Log;
  role: string;
}) => (
  <Box>
    <Box flexDirection='row' justifyContent='space-between'>
      <Box>
        <Text
          style={{
            flexShrink: 1,
            flexWrap: 'wrap',
          }}
          variant='body'
          color='textPrimary'
          fontWeight='700'
          fontSize={16}
          marginHorizontal='l'>
          {log?.user?.name?.toLocaleUpperCase()}
        </Text>
      </Box>
      <Box>
        <Text
          color='textPrimary'
          fontWeight='400'
          fontSize={16}
          marginHorizontal='l'>
          {format(
            log?.createdAt || '2025-03-12T05:30:00+05:30',
            'MMM dd, yyyy'
          )}
        </Text>
      </Box>
    </Box>
    <Box marginVertical='xxs'>
      <Text
        variant='body'
        color='textPrimary'
        fontWeight='400'
        fontSize={16}
        marginHorizontal='l'>
        {getProjectActivityMessage(log?.event, '', role)?.message !== ''
          ? getProjectActivityMessage(log?.event, '', role)?.message
          : log?.attachment?.body}
      </Text>
    </Box>
    <Box style={styles.horizonalLine}></Box>
  </Box>
);

const styles = StyleSheet.create({
  horizonalLine: {
    height: 1,
    alignSelf: Platform.OS === 'web' ? undefined : 'center',
    width:
      Platform.OS === 'web'
        ? Dimensions.get('window').width - 80
        : Dimensions.get('window').width - 60,
    maxWidth: 1200,
    backgroundColor: '#E8E8E8',
  },
});
